import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { NavigationRoutes } from './navigation-routes.model';

@Injectable({
  providedIn: 'root',
})
export class RoutingService {
  private history = [];

  constructor(private router: Router) {
  }

  public loadRouting(): void {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(({ urlAfterRedirects }: NavigationEnd) => {
        this.history = [...this.history, urlAfterRedirects];
      });
  }

  public getHistory(): string[] {
    return this.history;
  }

  public getPreviousUrl(): string {
    return this.history[this.history.length - 2] || '/';
  }

  public navigateToHome() {
    const route = '/';
    this.navigateToRoute(route, '');
  }

  public navigateToCompany() {
    const route = '/';
    this.navigateToRoute(route, 'company');
  }

  public navigateToBadBrowser(replaceUrl: string = '') {
    const route = '/' + NavigationRoutes.BadBrowserRoute;
    this.navigateToRoute(route, '');
  }

  public navigateToForbidden(replaceUrl: string = '') {
    const route = '/' + NavigationRoutes.ForbiddenRoute;
    this.navigateToRoute(route, replaceUrl);
  }

  public navigateToUnauthorized(replaceUrl: string = '') {
    const route = '/' + NavigationRoutes.UnauthorizedRoute;
    this.navigateToRoute(route, replaceUrl);
  }

  public navigateToMaintenance(replaceUrl: string = '') {
    const route = '/' + NavigationRoutes.MaintenanceRoute;
    this.navigateToRoute(route, replaceUrl);
  }
  public navigateToRecoverPassword(replaceUrl: string = '') {
    const route = NavigationRoutes.RecoverPassword;
    this.navigateToRoute(route, replaceUrl);
  }

  private navigateToRoute(route: string, replaceUrl: string) {
    if (replaceUrl) {
      this.router.navigate([route], { queryParams: { replaceUrl } });
    } else {
      this.router.navigate([route]);
    }
  }
}
